import * as actionTypes from "../actions/actionTypes";

const initialState = {
  products: [],
  loading: false,
  catalogLoading: false,
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_WISHLIST_SUCCESS:
      return {
        ...action.wishlist,
        loading: false,
        catalogLoading: false,
      };

    case actionTypes.ADD_TO_WISHLIST_SUCCESS:
      return {
        ...action.wishlist,
        loading: false,
        catalogLoading: false,
      };

    case actionTypes.REMOVE_FROM_WISHLIST_SUCCESS:
      return {
        ...action.wishlist,
        loading: false,
        catalogLoading: false,
      };

    case actionTypes.DOWNLOAD_CATALOG_LOAD:
      return {
        ...state,
        catalogLoading: true,
      };

    case actionTypes.DOWNLOAD_CATALOG_SUCCESS:
      return {
        ...state,
        catalogLoading: false,
      };

    default:
      return state;
  }
};

export default wishlistReducer;
